// This file is automatically generated. Do not edit manually.

import { ProductChangeRequestCatalogPartView } from "src/api/generated/erp/db/types/tables/productChangeRequestCatalogPartView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ProductChangeRequestCatalogPartsApi {
	export async function getConnectedCatalogParts(args: {
		productChangeRequestId: number;
	}): Promise<Array<ProductChangeRequestCatalogPartView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/requests/catalogParts/getConnectedCatalogParts",
			method: "POST",
			data: {
				productChangeRequestId: args.productChangeRequestId,
			},
		});
		return response as Array<ProductChangeRequestCatalogPartView>;
	}

	export async function connectCatalogParts(args: {
		productChangeRequestId: number;
		connections: Array<ProductChangeRequestCatalogPartsApi_ConnectCatalogPartDto>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/requests/catalogParts/connectCatalogParts",
			method: "POST",
			data: {
				productChangeRequestId: args.productChangeRequestId,
				connections: args.connections,
			},
		});
		return response as void;
	}

	export async function updateImpact(args: {
		productChangeRequestCatalogPartId: number;
		impact: string;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/requests/catalogParts/updateImpact",
			method: "POST",
			data: {
				productChangeRequestCatalogPartId: args.productChangeRequestCatalogPartId,
				impact: args.impact,
			},
		});
		return response as void;
	}

	export async function deleteConnections(args: {
		productChangeRequestCatalogPartIds: Array<number>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/requests/catalogParts/deleteConnections",
			method: "POST",
			data: {
				productChangeRequestCatalogPartIds: args.productChangeRequestCatalogPartIds,
			},
		});
		return response as void;
	}
}

export interface ProductChangeRequestCatalogPartsApi_ConnectCatalogPartDto {
	catalogPartId: number;
	impact: string;
}
